import React from 'react';

const Nf404 = () => (
  <div>
    <img src="https://images.unsplash.com/photo-1555861496-0666c8981751?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80" alt="Fallen Ice Cream"/>
    <h2>Page Not Found</h2>
  </div>
);

export default Nf404;